<template lang="html">
  <div class="video">
    <xgplayer ref="player" :options="playerOptions"></xgplayer>
    <div class="video__close hover" @click="closeVideo">back</div>
    <div class="video__info">
      <div class="video__infoBox">
        <p class="video__title">Client</p>
        <p class="video__subtitle">{{client}}</p>
      </div>
      <div class="video__infoBox">
        <p class="video__title">Director</p>
        <p class="video__subtitle">{{director}}</p>
      </div>
      <div class="video__infoBox">
        <p class="video__title">Made by</p>
        <p class="video__subtitle">{{madeBy}}</p>
      </div>
    </div>
  </div>
</template>

<script>
import playButton from '../assets/play.svg'
import pauseButton from '../assets/viewwork.svg'

export default {
  name: 'Video',
  mounted() {
    document.querySelector('.video').style.height = window.innerHeight + 'px';
    var element = document.querySelector('.vue-xgplayer')
    this.observer = new MutationObserver(function(event) {
      const classes = event[0].target.className;
      if (classes !== this.lastClasses) this.lastClasses = classes;
      else return;
      if (/xgplayer-inactive/.test(event[0].target.className)) document.querySelector('.video__info').classList.add('hidden');
      else document.querySelector('.video__info').classList.remove('hidden');
    })

    this.observer.observe(element, {
      attributes: true,
      attributeFilter: ['class'],
      childList: false,
      characterData: false
    })
  },
  destroy() {
    this.observer.disconnect();
  },
  data() {
    return {
      lastClasses: ''
    }
  },
  computed: {
    source() {
      return this.$store.getters.selectedWork.videoLong;
    },
    client() {
      return this.$store.getters.selectedWork.client;
    },
    director() {
      return this.$store.getters.selectedWork.director;
    },
    madeBy() {
      return this.$store.getters.selectedWork.madeBy;
    },
    playerOptions() {
      return {
        url: this.source,
        autoplay: true,
        loop: true,
        width: '100%'
      }
    }
  },
  methods: {
    closeVideo() {
      this.$store.commit('closeVideo');
    }
  },

}
</script>

<style lang="scss">
@import "../styles/config.scss";
.video {
  width: 100vw;
  height: 100vh;
  margin: 0 auto;
  z-index: 10;
  background-color: var(--Neu11);
  position: fixed;
  top: 0;
  left: 0;
  &__close {
    font-family: CamptonBold;
    font-size: 12px;
    color: var(--Neu01);
    position: absolute;
    top: 100px;
    left: calc(10% - 60px);
    padding-top: 12px;
    z-index: 2;
    &:before,&:after {
      content: '';
      display: block;
      height: 4px;
      border-radius: 5px;
      border: 1px solid var(--M01);
      top: 0;
      position: absolute;
    }
    &:before {
      width: 4px;
      left: 9px;
    }
    &:after {
      width: 20px;
      left: 17px;
    }
  }
  &__info {
    position: absolute;
    bottom: 80px;
    left: 10%;
    opacity: 1;
    transition: opacity .2s ease-in;
    z-index: 2;
    pointer-events: none;
    &.hidden {
      opacity: 0;
    }
  }
  &__infoBox {
    pointer-events: none;
    display: inline-block;
    vertical-align: bottom;
    text-align: left;
    margin-right: 20px;
    max-width: 140px;
  }
  &__title {
    font-family: CamptonBold;
    font-size: 12px;
    color: var(--Neu01);
    margin-bottom: 5px;
    pointer-events: none;
  }
  &__subtitle {
    pointer-events: none;
    font-family: CamptonBook;
    font-size: 12px;
    color: var(--Neu01);
  }
  @include mq(0,767px) {

    &__info {
      left: 0;
      padding: 0px 17px;
      bottom: 80px;
    }
    &__infoBox {
      display: block;
      margin-top: 10px;
      margin-right: 0;
      max-width: none;
    }
    &__close {
      left: 20px;
      top: 20px;
    }
  }
}
.xgplayer {
  height: 100% !important;
  z-index: 1;
  video {
    // object-fit: cover;
    width: 100%;
    height: auto;
    outline: none;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%,-50%);
  }
  &-controls {
    bottom: 20px !important;
    background-image: none !important;
    height: 20px !important;
    &:before {
      content: '';
      position: absolute;
      display: block;
      background: linear-gradient(to bottom, rgba(0,0,0,0) 0%,rgba(0,0,0,1) 100%);
      height: 150px;
      width: 100%;
      bottom: -20px;
      left: 0;
      z-index: 0;
    }
  }
  &-volume,
  &-fullscreen {
    display: none!important;
  }
  &-time {
    position: absolute!important;
    bottom: 20px!important;
    right: calc(10% - 60px)!important;
    span {
      color: var(--Neu01)!important;
      font-family: CamptonBook!important;
      &:after {
        content: ''!important;
      }
    }
    em {
      display: none!important;
    }
  }
  &-play {
    position: absolute!important;
    bottom: 15px!important;
    left: calc(10% - 60px)!important;
  }
  &-progress {
    left: 10%!important;
    right: 10%!important;
    top: -30px!important;
    &:hover .xgplayer-progress-outer,
    &:focus .xgplayer-progress-outer {
      height: 4px!important;
      margin-top: 8.5px!important;
    }

  }
  &-progress-outer {
    background: transparent!important;
    border: 1px solid var(--M01)!important;
    border-radius: 5px!important;
    height: 4px!important;
  }
  &-progress-played {
    background-color: var(--Neu01)!important;
    background-image: none!important;
    border-radius: 5px!important;
    height: 4px!important;
    top: -1px!important;
    left: -2px!important;
    z-index: 1!important;
  }
  &-progress-cache {
    display: none!important;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Video.vue